import { render, staticRenderFns } from "./RejectedCandidates.vue?vue&type=template&id=2cd5a66c&"
import script from "./RejectedCandidates.vue?vue&type=script&lang=js&"
export * from "./RejectedCandidates.vue?vue&type=script&lang=js&"
import style0 from "./RejectedCandidates.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RejectedCandidates.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports